"use strict";
/*
 * Created on 06.04.2021
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionPerformanceRowSupplierInfo_1 = require("../model/PromotionPerformanceRowSupplierInfo");

var PromotionPerformanceRowSupplierInfoConverter_1 = require("./PromotionPerformanceRowSupplierInfoConverter");
/**
 * @author Tomas Leity
 */


var PromotionPerformanceRowSupplierInfoConverterImpl =
/*#__PURE__*/
function (_PromotionPerformance) {
  _inherits(PromotionPerformanceRowSupplierInfoConverterImpl, _PromotionPerformance);

  function PromotionPerformanceRowSupplierInfoConverterImpl() {
    _classCallCheck(this, PromotionPerformanceRowSupplierInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceRowSupplierInfoConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionPerformanceRowSupplierInfoConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo(PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.schema.preferred.valueOf(source.preferred), PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        preferred: source.preferred,
        promoVolume: conversions.fromBigNumber(source.promoVolume)
      });
      return result;
    }
  }]);

  return PromotionPerformanceRowSupplierInfoConverterImpl;
}(PromotionPerformanceRowSupplierInfoConverter_1.PromotionPerformanceRowSupplierInfoConverter);

exports.PromotionPerformanceRowSupplierInfoConverterImpl = PromotionPerformanceRowSupplierInfoConverterImpl;